/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ code: NonNullable<unknown> }} Planshare_Share_TextInputs */

const en_us2_planshare_share_text = /** @type {(inputs: Planshare_Share_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`My training plan on MyPocketGym. In the app, open Profile › Share or import a plan and enter the code ${i?.code}.`)
};

const pt_br2_planshare_share_text = /** @type {(inputs: Planshare_Share_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Meu plano de treino no MyPocketGym. No app, abra Perfil › Compartilhar ou importar plano e use o código ${i?.code}.`)
};

const pt_pt2_planshare_share_text = /** @type {(inputs: Planshare_Share_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Meu plano de treino no MyPocketGym. No app, abra Perfil › Compartilhar ou importar plano e use o código ${i?.code}.`)
};

/** @type {(inputs: Planshare_Share_TextInputs) => LocalizedString} */
const es_419_planshare_share_text = en_us2_planshare_share_text;

/** @type {(inputs: Planshare_Share_TextInputs) => LocalizedString} */
const fr_fr2_planshare_share_text = en_us2_planshare_share_text;

/** @type {(inputs: Planshare_Share_TextInputs) => LocalizedString} */
const de_de2_planshare_share_text = en_us2_planshare_share_text;

/** @type {(inputs: Planshare_Share_TextInputs) => LocalizedString} */
const it_it2_planshare_share_text = en_us2_planshare_share_text;

/**
* | output |
* | --- |
* | "My training plan on MyPocketGym. In the app, open Profile › Share or import a plan and enter the code {code}." |
*
* @param {Planshare_Share_TextInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const planshare_share_text = /** @type {((inputs: Planshare_Share_TextInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planshare_Share_TextInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_planshare_share_text(inputs)
	if (locale === "es-419") return es_419_planshare_share_text(inputs)
	if (locale === "pt-PT") return pt_pt2_planshare_share_text(inputs)
	if (locale === "fr-FR") return fr_fr2_planshare_share_text(inputs)
	if (locale === "de-DE") return de_de2_planshare_share_text(inputs)
	if (locale === "it-IT") return it_it2_planshare_share_text(inputs)
	return en_us2_planshare_share_text(inputs)
});
export { planshare_share_text as "planshare.share_text" }